import './KPIShell.css';

export default function KpiShell({ title, value, danger = false }) {
  return (
    <div className={`kpi-shell${danger ? ' kpi-danger' : ''}`}>
      <div className="kpi-title">{title}</div>
      <div className="kpi-value">{value}</div>
    </div>
  );
}
